export var FeedbackFields;
(function (FeedbackFields) {
    FeedbackFields["CONTENT"] = "Content";
    FeedbackFields["FILES"] = "Files";
    FeedbackFields["CONFIGURATION"] = "Configuration";
    FeedbackFields["STATUS"] = "Status";
})(FeedbackFields || (FeedbackFields = {}));
